const secondaryNavSlider = document.querySelectorAll('[data-slider="secondary-nav-slider"]');

const secondaryNavSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    767: {
      slidesPerView: 3,
      spaceBetween: 0,
    },
  },
};

// Scroll To Active Link
const scrollActiveLinkIntoView = (container) => {
  const activeLink = container.querySelector('.secondary-nav__link.is-active');

  if (!activeLink) {
    return;
  }

  // activeLink.scrollIntoView({
  //   behavior: 'smooth',
  //   inline: 'center',
  //   block: 'nearest',
  // });

  container.scrollBy({
    left:
      activeLink.getBoundingClientRect().left -
      container.getBoundingClientRect().left -
      (container.clientWidth - activeLink.offsetWidth) / 2,
    behavior: 'smooth',
  });
};

const isSlideVisible = (swiper, slide) => {
  const slideRect = slide.getBoundingClientRect();
  const containerRect = swiper.el.getBoundingClientRect();

  return slideRect.left >= containerRect.left && slideRect.right <= containerRect.right;
};

const observeActiveSlide = (container, swiper = null) => {
  const observer = new MutationObserver((mutations) => {
    const hasActiveChange = mutations.some(
      (mutation) =>
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class' &&
        mutation.target.classList.contains('secondary-nav__link'),
    );

    if (!hasActiveChange) {
      return;
    }

    const activeLink = container.querySelector('.secondary-nav__link.is-active');

    if (!activeLink) {
      return;
    }

    // Desktop swiper
    if (swiper?.slides?.length) {
      const slide = activeLink.closest('.swiper-slide');

      if (!slide || isSlideVisible(swiper, slide)) {
        return;
      }

      swiper.slideTo([...swiper.slides].indexOf(slide), 300);

      return;
    }

    // Mobile horizontal scroll
    scrollActiveLinkIntoView(container);
  });

  observer.observe(container, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });
};

const initSecondaryNavSlider = (el) => {
  const parentEle = el.closest('.secondary-nav');
  const twoSlides = parentEle.hasAttribute('data-two-slides');
  const arrowRight = parentEle.querySelector('.arrow-right');
  const arrowLeft = parentEle.querySelector('.arrow-left');

  const options = {
    ...secondaryNavSliderOptions,
    navigation: {
      prevEl: arrowLeft,
      nextEl: arrowRight,
    },
    breakpoints: {
      767: {
        slidesPerView: twoSlides ? 2 : 3,
        spaceBetween: 0,
      },
    },
  };

  const swiper = new Swiper(el, options);

  if (windowWidth() < breakpointMd) {
    observeActiveSlide(parentEle.querySelector('.swiper'));
  } else {
    observeActiveSlide(swiper.el, swiper);
  }
};

secondaryNavSlider.forEach((el) => initSecondaryNavSlider(el));

setupResponsiveSliders({
  sliderElements: secondaryNavSlider,
  breakpoint: breakpointSm,
  initSlider: initSecondaryNavSlider,
  mobileFallback: [enableArrowScrollSync],
  parentSelector: '[data-slider-parent]',
});
